import { BonusHistory } from '@my-account/const';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { MyAccountState, StateWithMyAccount } from '../my-account-state';
import { getMyAccountState } from './state.selectors';

export const getBonusHistoryState: MemoizedSelector<
  StateWithMyAccount,
  StateUtils.LoaderState<BonusHistory>
> = createSelector(getMyAccountState, (state: MyAccountState) => state.bonusHistory);

export const getBonusHistoryValue: MemoizedSelector<StateWithMyAccount, BonusHistory> = createSelector(
  getBonusHistoryState,
  (state) => StateUtils.loaderValueSelector(state),
);
